import { nonEmptyTrimmedStringFromUnknown } from "../protocol/shared.js";
import { clientMessageIdSchema } from "../protocol/client-message-id.js";
import { spaceDispatchTraceAttemptStatusSchema, spaceDispatchTraceDispatchStatusSchema } from "./space-dispatch-trace.js";
import { z } from "zod/v4";
//#region src/schemas/http/space-dispatch-lookup.ts
const optionalSelectorSchema = z.preprocess((value) => {
	const normalized = String(value ?? "").trim();
	return normalized.length > 0 ? normalized : void 0;
}, z.string().min(1).optional());
const optionalClientMessageIdSchema = z.preprocess((value) => {
	const normalized = String(value ?? "").trim();
	return normalized.length > 0 ? normalized : void 0;
}, clientMessageIdSchema.optional());
const getSpaceDispatchLookupInputSchema = z.strictObject({
	spaceId: nonEmptyTrimmedStringFromUnknown,
	sourceSignalId: optionalSelectorSchema,
	clientMessageId: optionalClientMessageIdSchema,
	targetProfileId: optionalSelectorSchema
}).superRefine((value, context) => {
	if (Number(value.sourceSignalId !== void 0) + Number(value.clientMessageId !== void 0) === 1) return;
	context.addIssue({
		code: "custom",
		message: "exactly one of sourceSignalId or clientMessageId is required",
		path: ["sourceSignalId"]
	});
});
const spaceDispatchLookupMatchSchema = z.strictObject({
	dispatchId: z.string().trim().min(1),
	sourceSignalId: z.string().trim().min(1),
	targetProfileId: z.string().trim().min(1),
	status: spaceDispatchTraceDispatchStatusSchema,
	attemptCount: z.int().min(0),
	latestAttemptId: z.string().trim().min(1).nullable(),
	latestAttemptStatus: spaceDispatchTraceAttemptStatusSchema.nullable(),
	latestAttemptErrorCode: z.string().trim().min(1).nullable(),
	latestAttemptErrorMessage: z.string().trim().min(1).nullable()
});
const getSpaceDispatchLookupResponseSchema = z.strictObject({
	query: z.strictObject({
		spaceId: z.string().trim().min(1),
		sourceSignalId: z.string().trim().min(1).nullable(),
		clientMessageId: clientMessageIdSchema.nullable(),
		targetProfileId: z.string().trim().min(1).nullable()
	}),
	matches: z.array(spaceDispatchLookupMatchSchema)
});
//#endregion
export { getSpaceDispatchLookupInputSchema, getSpaceDispatchLookupResponseSchema, spaceDispatchLookupMatchSchema };

//# sourceMappingURL=space-dispatch-lookup.js.map